// Full team list for Copa Argentina (includes Liga Profesional + lower division clubs)
const CopaArgentinaTeams = {
  ACASSUSO: "Acassuso",
  AGROPECUARIO: "Agropecuario",
  ALDOSIVI: "Aldosivi",
  ARGENTINO_MERLO: "Argentino de Merlo",
  ARGENTINO_MONTE_MAIZ: "Argentino de Monte Maíz",
  ARGENTINOS_JRS: "Argentinos Juniors",
  ATENAS_RC: "Atenas de Río Cuarto",
  ATLETICO_RAFAELA: "Atlético de Rafaela",
  ATLETICO_TUCUMAN: "Atlético Tucumán",
  ATLANTA: "Atlanta",
  BANFIELD: "Banfield",
  BARRACAS_CENTRAL: "Barracas Central",
  BELGRANO: "Belgrano",
  BOCA_JRS: "Boca Juniors",
  CENTRAL_CORDOBA: "Central Córdoba (SdE)",
  CHACO_FOR_EVER: "Chaco For Ever",
  CIUDAD_BOLIVAR: "Ciudad de Bolívar",
  CLAYPOLE: "Claypole",
  COLON: "Colón de Santa Fe",
  DEFENSA_Y_JUSTICIA: "Defensa y Justicia",
  DEP_ARMENIO: "Deportivo Armenio",
  DEP_CAMIONEROS: "Deportivo Camioneros",
  DEP_MADRYN: "Deportivo Madryn",
  DEP_MAIPU: "Deportivo Maipú",
  DEP_MORON: "Deportivo Morón",
  DEP_RINCON: "Deportivo Rincón",
  RIESTRA: "Deportivo Riestra",
  ESTUDIANTES_LP: "Estudiantes de La Plata",
  ESTUDIANTES_RC: "Estudiantes de Río Cuarto",
  ESTUDIANTES_BA: "Estudiantes de Buenos Aires",
  FERROCARRIL_MIDLAND: "Ferrocarril Midland",
  GIMNASIA_CHIVILCOY: "Gimnasia y Esgrima de Chivilcoy",
  GIMNASIA_MENDOZA: "Gimnasia y Esgrima de Mendoza",
  GIMNASIA_LP: "Gimnasia y Esgrima La Plata",
  GIMNASIA_TIRO_SALTA: "Gimnasia y Tiro de Salta",
  HURACAN: "Huracán",
  INDEPENDIENTE: "Independiente",
  INDEPENDIENTE_RIVADAVIA: "Independiente Rivadavia",
  INSTITUTO_CBA: "Instituto",
  ITUZAINGO: "Ituzaingó",
  LANUS: "Lanús",
  NEWELLS_OLD_BOYS: "Newell's Old Boys",
  OLIMPO: "Olimpo",
  PLATENSE: "Platense",
  QUILMES: "Quilmes",
  RACING_CLUB: "Racing Club",
  REAL_PILAR: "Real Pilar",
  RIVER_PLATE: "River Plate",
  ROSARIO_CENTRAL: "Rosario Central",
  SAN_LORENZO: "San Lorenzo",
  SAN_MARTIN_FORMOSA: "San Martín de Formosa",
  SAN_MARTIN_SJ: "San Martín de San Juan",
  SAN_MARTIN_TUC: "San Martín de Tucumán",
  SAN_MIGUEL: "San Miguel",
  SARMIENTO: "Sarmiento de Junín",
  SARMIENTO_BANDA: "Sarmiento de La Banda",
  SPORTIVO_BARRACAS: "Sportivo Barracas",
  SPORTIVO_BELGRANO: "Sportivo Belgrano",
  TALLERES: "Talleres de Córdoba",
  TEMPERLEY: "Temperley",
  TIGRE: "Tigre",
  TRISTAN_SUAREZ: "Tristán Suárez",
  UNION: "Unión de Santa Fe",
  VELEZ: "Vélez Sarsfield",
};

export default CopaArgentinaTeams;
